/**
 * name of Dashboard widget class
 */
export const DXPDashboardWidgetClass = 'DXPDashboardWidget'
